export const SET_TESTING_STATUS = 'setTestingStatus';
export const SET_CURRENT_PARSER = 'setCurrentParser';



// WEBPACK FOOTER //
// ./src/modules/NER/_store/mutations_type.js